import { actionCreator, ActionReturnType, Loading, loadingFinished, loadingIsLoading, loadingNotStarted } from "@itk/typescript-utils";
import { AddEditDialogProp, ContactPersonExtendedGet, ContactPersonPermissionReplacePut, ContactPersonPut } from "./user-management-types";

export enum Action {
  SetAddEditDialogProps = "@@ITK:SRC:PAGES:INFORMATION:COMPONENTS:USER-MANAGEMENT:USER-MANAGEMENT-STORE.TS:ACTION:SETADDEDITDIALOGPROPS",

  EmailExistsRequest = "@@ITK:SRC:PAGES:INFORMATION:COMPONENTS:USER-MANAGEMENT:USER-MANAGEMENT-STORE.TS:ACTION:EMAILEXISTSREQUEST",
  EmailExistsFail = "@@ITK:SRC:PAGES:INFORMATION:COMPONENTS:USER-MANAGEMENT:USER-MANAGEMENT-STORE.TS:ACTION:EMAILEXISTSFAIL",
  EmailExistsSuccess = "@@ITK:SRC:PAGES:INFORMATION:COMPONENTS:USER-MANAGEMENT:USER-MANAGEMENT-STORE.TS:ACTION:EMAILEXISTSSUCCESS",

  SetReloadList = "@@ITK:SRC:PAGES:INFORMATION:COMPONENTS:USER-MANAGEMENT:USER-MANAGEMENT-STORE.TS:ACTION:SETRELOADLIST",
  Clear = "@@ITK:SRC:PAGES:INFORMATION:COMPONENTS:USER-MANAGEMENT:USER-MANAGEMENT-STORE.TS:ACTION:CLEAR",

  PostEmailSendloginRequest = "@@ITK:SRC:PAGES:INFORMATION:COMPONENTS:USER-MANAGEMENT:USER-MANAGEMENT-STORE.TS:ACTION:POSTEMAILSENDLOGINREQUEST",
  PostEmailSendloginSuccess = "@@ITK:SRC:PAGES:INFORMATION:COMPONENTS:USER-MANAGEMENT:USER-MANAGEMENT-STORE.TS:ACTION:POSTEMAILSENDLOGINSUCCESS",
  SetHasChanges = "@@ITK:SRC:PAGES:INFORMATION:COMPONENTS:USER-MANAGEMENT:USER-MANAGEMENT-STORE.TS:ACTION:SETHASCHANGES",
  SetIsSubmitting = "@@ITK:SRC:PAGES:INFORMATION:COMPONENTS:USER-MANAGEMENT:USER-MANAGEMENT-STORE.TS:ACTION:SETISSUBMITTING",

  GetContactPersonsRequest = "@@ITK:SRC:PAGES:INFORMATION:COMPONENTS:USER-MANAGEMENT:USER-MANAGEMENT-STORE.TS:ACTION:GETCONTACTPERSONSREQUEST",
  GetContactPersonsSuccess = "@@ITK:SRC:PAGES:INFORMATION:COMPONENTS:USER-MANAGEMENT:USER-MANAGEMENT-STORE.TS:ACTION:GETCONTACTPERSONSSUCCESS",

  SetListShouldReload = "@@ITK:SRC:PAGES:INFORMATION:COMPONENTS:USER-MANAGEMENT:USER-MANAGEMENT-STORE.TS:ACTION:SETLISTSHOULDRELOAD",

  DeleteContactPersonRequest = "@@ITK:SRC:PAGES:INFORMATION:COMPONENTS:USER-MANAGEMENT:USER-MANAGEMENT-STORE.TS:ACTION:DELETECONTACTPERSONREQUEST",

  GetContactPersonByContactPersonIdRequest = "@@ITK:SRC:PAGES:INFORMATION:COMPONENTS:USER-MANAGEMENT:USER-MANAGEMENT-STORE.TS:ACTION:GETCONTACTPERSONBYCONTACTPERSONIDREQUEST",
  GetContactPersonByContactPersonIdSuccess = "@@ITK:SRC:PAGES:INFORMATION:COMPONENTS:USER-MANAGEMENT:USER-MANAGEMENT-STORE.TS:ACTION:GETCONTACTPERSONBYCONTACTPERSONIDSUCCESS",

  PutContacPersonRequest = "@@ITK:SRC:PAGES:INFORMATION:COMPONENTS:USER-MANAGEMENT:USER-MANAGEMENT-STORE.TS:ACTION:PUTCONTACPERSONREQUEST",
  PutContacPersonSuccess = "@@ITK:SRC:PAGES:INFORMATION:COMPONENTS:USER-MANAGEMENT:USER-MANAGEMENT-STORE.TS:ACTION:PUTCONTACPERSONSUCCESS",
  PutContactPersonPermissionRequest = "@@ITK:SRC:PAGES:INFORMATION:COMPONENTS:USER-MANAGEMENT:USER-MANAGEMENT-STORE.TS:ACTION:PUTCONTACTPERSONPERMISSIONREQUEST",
  PutContactPersonPermissionSuccess = "@@ITK:SRC:PAGES:INFORMATION:COMPONENTS:USER-MANAGEMENT:USER-MANAGEMENT-STORE.TS:ACTION:PUTCONTACTPERSONPERMISSIONSUCCESS"
}

type UserMananementState = {
  contactPersonsLoading: Loading<ContactPersonExtendedGet[]>;
  editContactPersonLoading: Loading<ContactPersonExtendedGet>;
  addEditDialogProps: AddEditDialogProp | undefined;
  submitting: boolean;
  hasChanges: boolean;
  isAlreadyExists: boolean;
  listShouldReload: boolean;
};

const initialState: UserMananementState = {
  contactPersonsLoading: loadingNotStarted,
  editContactPersonLoading: loadingNotStarted,
  addEditDialogProps: undefined,
  submitting: false,
  hasChanges: false,
  isAlreadyExists: false,
  listShouldReload: false
};

export const userManagementActions = {
  setAddEditDialogProps: (data: AddEditDialogProp | undefined) => actionCreator(Action.SetAddEditDialogProps, { data }),

  emailExistsRequest: (email: string, requestId: string, customerId: string) => actionCreator(Action.EmailExistsRequest, { email, requestId, customerId }),
  emailExistsFail: (isAlreadyExists: boolean) => actionCreator(Action.EmailExistsFail, { isAlreadyExists }),

  clear: () => actionCreator(Action.Clear),

  postEmailSendloginRequest: (email: string, customerId: string) => actionCreator(Action.PostEmailSendloginRequest, { email, customerId }),
  postEmailSendloginSuccess: (publicHolidayRuleSetId: string) => actionCreator(Action.PostEmailSendloginSuccess, { publicHolidayRuleSetId }),
  setHasChanges: (hasChanges: boolean) => actionCreator(Action.SetHasChanges, { hasChanges }),
  setIsSubmitting: (submitting: boolean) => actionCreator(Action.SetIsSubmitting, { submitting }),

  getContactPersonsRequest: (customerId: string) => actionCreator(Action.GetContactPersonsRequest, { customerId }),
  getContactPersonsSuccess: (data: ContactPersonExtendedGet[]) => actionCreator(Action.GetContactPersonsSuccess, { data }),

  setListShouldReload: (listShouldReload: boolean) => actionCreator(Action.SetListShouldReload, { listShouldReload }),
  deleteContactPersonRequest: (contactPersonId: string) => actionCreator(Action.DeleteContactPersonRequest, { contactPersonId }),

  getContactPersonByContactPersonIdRequest: (contactPersonId: string) => actionCreator(Action.GetContactPersonByContactPersonIdRequest, { contactPersonId }),
  getContactPersonByContactPersonIdSuccess: (data: ContactPersonExtendedGet) => actionCreator(Action.GetContactPersonByContactPersonIdSuccess, { data }),
  putContactPersonRequest: (contactPersonId: string, data: ContactPersonPut) => actionCreator(Action.PutContacPersonRequest, { contactPersonId, data }),
  putContactPersonSuccess: () => actionCreator(Action.PutContacPersonSuccess, {}),
  putContactPersonPermissionRequest: (contactPersonId: string, data: ContactPersonPermissionReplacePut) => actionCreator(Action.PutContactPersonPermissionRequest, { contactPersonId, data }),
  putContactPersonPermissionSuccess: () => actionCreator(Action.PutContactPersonPermissionSuccess, {})
};

export const userMananementReducer = (state = initialState, action: ActionReturnType<typeof userManagementActions>): UserMananementState => {
  switch (action.type) {
    case Action.SetAddEditDialogProps:
      return { ...state, addEditDialogProps: action.payload.data };
    case Action.EmailExistsRequest:
      return { ...state };
    case Action.Clear:
      return { ...state, addEditDialogProps: undefined };
    case Action.PostEmailSendloginRequest:
      return { ...state, submitting: true };
    case Action.PostEmailSendloginSuccess:
      return { ...state, addEditDialogProps: undefined, submitting: false };
    case Action.SetHasChanges:
      return { ...state, hasChanges: action.payload.hasChanges };
    case Action.SetIsSubmitting:
      return { ...state, submitting: action.payload.submitting };
    case Action.GetContactPersonsRequest:
      return { ...state, contactPersonsLoading: loadingIsLoading };
    case Action.GetContactPersonsSuccess:
      return { ...state, contactPersonsLoading: loadingFinished(action.payload.data) };
    case Action.SetListShouldReload:
      return { ...state, listShouldReload: action.payload.listShouldReload };
    case Action.GetContactPersonByContactPersonIdRequest:
      return { ...state, editContactPersonLoading: loadingIsLoading };
    case Action.GetContactPersonByContactPersonIdSuccess:
      return { ...state, editContactPersonLoading: loadingFinished(action.payload.data) };
    case Action.PutContacPersonRequest:
      return { ...state, submitting: true };
    case Action.PutContacPersonSuccess:
      return { ...state, submitting: false };
    case Action.PutContactPersonPermissionRequest:
      return { ...state, submitting: true };
    case Action.PutContactPersonPermissionSuccess:
      return { ...state, submitting: false };
    default:
      return state;
  }
};
